import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import { imageUrl } from '../lib/images';

export default function HegnPage() {
  const hegnTypes = [
    {
      title: "Komposithegn",
      desc: "Moderne, vedligeholdelsesfrit og holdbart i alt slags vejr.",
      image: "/_assets/komposithegn-laage.webp",
      href: "/komposithegn",
    },
    {
      title: "Industrihegn",
      desc: "Pålidelig perimetersikring til erhverv, tekniske anlæg og virksomheder.",
      image: "/_assets/industrihegn-02.webp",
      href: "/industrihegn",
    },
    {
      title: "Støjhegn",
      desc: "Effektiv afskærmning mod støj og vind tilpasset dine omgivelser.",
      image: "/_assets/betonhegn-02.webp",
      href: "/stoejhegn",
    },
    {
      title: "Panelhegn",
      desc: "Klassisk og stabilt valg til både bolig og erhverv.",
      image: "/_assets/panelhegn.webp",
      href: "/panelhegn",
    },
    {
      title: "Smedejernshegn",
      desc: "Eksklusivt, tidløst og særdeles robust.",
      image: "/_assets/480188274-1283354403152757-3860986236524628895-n.jpg",
      href: "/smedejernshegn",
    },
    {
      title: "Rionet",
      desc: "Enkelt, stilrent og perfekt til klatreplanter og grønne løsninger.",
      image: "/_assets/480220622-1283354609819403-454519828912243296-n.jpg",
      href: "/rionet",
    },
    {
      title: "Betonhegn",
      desc: "Solidt, støjdæmpende og vedligeholdelsesfrit hegn.",
      image: "/_assets/betonhegn-01.webp",
      href: "/betonhegn",
    },
    {
      title: "Træbeklædt hegn",
      desc: "Naturligt, varmt og stabilt valg til enhver have.",
      image: "/_assets/fb-img-1760014086552.jpg",
      href: "/traebeklaedt-hegn-et-naturligt-valg",
    },
  ];

  return (
    <>
      <SEO
        title="Hegn – skabt til funktion, kvalitet og design | Hovendals"
        description="Hegn i kvalitet og stil Hos Hovendal tilbyder vi hegn, der forener funktionalitet med et flot design. Uanset om du ønsker et moderne komposithegn, et klassisk panelhegn eller et eksklusivt smedejernshegn, leverer vi løsninger, der både holder og klæder din ejendom. Vi tilbyder blandt andet:"
        ogImage="/_assets/485170711-1308137817341082-5036954073090041011-n-1_b28c5adc.jpg"
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src={imageUrl("/_assets/485170711-1308137817341082-5036954073090041011-n-1_b28c5adc.jpg", "width=1600,quality=80,format=auto")}
            alt="Hegn fra Hovendals"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#004fa4]/20 text-[#c2ccdf] border border-[#004fa4]/30">
              <i className="fa-sharp fa-solid fa-fence" aria-hidden="true"></i>
              <span>Hegnløsninger</span>
            </div>
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white">
              Hegn – skabt til funktion, kvalitet og design
            </h1>
            <p className="text-lg text-slate-300 leading-relaxed font-normal">
              Hos Hovendals tilbyder vi hegnsløsninger, der både skaber tryghed, privatliv og et flot udtryk omkring dit hjem eller din virksomhed. Vi arbejder med flere forskellige typer hegn, så du kan få en løsning, der passer præcis til dine ønsker og behov.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mb-16">
            <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Håndværk & holdbarhed</span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight mt-1 mb-6">
              Hegn i kvalitet og stil
            </h2>
            <p className="text-base text-slate-700 leading-relaxed mb-6">
              Hos Hovendal tilbyder vi hegn, der forener funktionalitet med et flot design. Uanset om du ønsker et moderne komposithegn, et klassisk panelhegn eller et eksklusivt smedejernshegn, leverer vi løsninger, der både holder og klæder din ejendom.
            </p>
            <p className="text-base text-slate-700 leading-relaxed font-medium">
              Med et hegn fra Hovendals får du ikke blot en praktisk afgrænsning, men også en æstetisk løsning, der løfter helhedsindtrykket af din ejendom.
            </p>
          </div>

          {/* Hegn types grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {hegnTypes.map((item) => (
              <div
                key={item.title}
                className="bg-slate-50 rounded-2xl overflow-hidden border border-slate-200/80 shadow-sm hover:shadow-lg transition-all flex flex-col group"
              >
                <div className="relative h-56 overflow-hidden bg-slate-900">
                  <img
                    src={imageUrl(item.image, "width=600,quality=80,format=auto")}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-4 left-4 bg-slate-900/80 backdrop-blur-sm text-[#c2ccdf] text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full">
                    {item.title}
                  </div>
                </div>
                <div className="p-6 flex-grow flex flex-col justify-between">
                  <div>
                    <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-[#004fa4] transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-sm text-slate-600 leading-relaxed mb-4">
                      {item.desc}
                    </p>
                  </div>
                  <div className="pt-4 border-t border-slate-200/60">
                    <Link
                      to={item.href}
                      className="inline-flex items-center gap-2 text-sm font-bold text-[#004fa4] hover:text-[#183e7f]"
                    >
                      <span>Læs mere om {item.title.toLowerCase()}</span>
                      <i className="fa-sharp fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />
    </>
  );
}
